export const FETCH_EPG_MENU_INIT = 'FETCH_EPG_MENU_INIT';
export const FETCH_EPG_MENU_SUCCESS = 'FETCH_EPG_MENU_SUCCESS';
export const FETCH_EPG_MENU_ERROR = 'FETCH_EPG_MENU_ERROR';
